import withSort from '../../elements/HOC/withSort'
import withSpinning from '../../elements/HOC/withSpinning'
import withSubDropdown from '../../elements/HOC/withSubDropdown'
import withSelectFetch from '../../elements/Select/withSelectFetch'
import React from 'react'
import {compose} from 'recompose'
import CustomSelect from '../../elements/Select/CustomSelect'

const ProjectType = compose(
  withSelectFetch({dropdown: 'project', name: 'project'}),
  withSpinning,
  withSubDropdown({name: 'type'}),
  withSort,
)(CustomSelect)

export default ProjectType
